import { render, staticRenderFns } from "./customerDM.vue?vue&type=template&id=72b8ec95"
import script from "./customerDM.ts?vue&type=script&lang=js&external"
export * from "./customerDM.ts?vue&type=script&lang=js&external"
import style0 from "../customer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports